import './logo-app/index'
import './qr-app/index'
import './nfc-app/index'
